module.exports = __webpack_public_path__ + "static/img/hero_768.01614e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hero_768.png
// module id = 3OD7
// module chunks = 0